import React, {useState} from "react";
import TabTitle from "../../components/tabTitle/TabTitle";
import styled from "styled-components";
import {useTranslation} from "react-i18next";
import './MarketClusteringStyles.css'
import MarketClusteringContentComponent from "./components/MarketClusteringContentComponent";
import withLoadingAnimation from "../AnimationWrapper/AnimationWrapper";
import MarketClusteringDetailComponent from "./components/MarketClusteringDetailComponent";
import TabHeader from "../tabHeader/TabHeader";
import TabFooter from "../tabFooter/TabFooter";
import HeaderContainer from "../Commons/HeaderContainer";
import BodyContainer from "../Commons/BodyContainer";
import FooterContainer from "../Commons/FooterContainer";
import Tab from "../tab/Tab";

const MarketClusteringContent = styled.div`
    @media (min-width: 481px) {
        display: flex;
        flex-direction: column;
        flex: 1;
        height: 100%;

        h3 {
          margin-top: 0px;
        }
    }

    @media (max-width: 480px) {
        display: flex;
        flex-direction: column;
        flex: 1;
        overflow: scroll;
        padding: 10px;
    }
`;

const MarketClusteringComponent: React.FC<{ isTabSelected: boolean }> = ({isTabSelected}) => {
    const { t } = useTranslation();
    const [detailsOpen, setDetailsOpen] = useState<boolean>(false);
    const tabContent = (
      <MarketClusteringContent>
          <div className={'marketClusterContentContainer'}>
              {
                  withLoadingAnimation(
                      <MarketClusteringDetailComponent closeDetails={() => setDetailsOpen(false)}/>,
                      <MarketClusteringContentComponent openDetails={() => setDetailsOpen(true)}/>,
                      detailsOpen
                  )
              }
          </div>
      </MarketClusteringContent>
    );

    return (
      <Tab
        isOpen={ isTabSelected }
        title={
          <TabTitle
              title={t('latamMarketConcentration.tabTitle')}
              isTabSelected={isTabSelected}
          />
        }
        body={ tabContent }
        footer={ <TabFooter /> }
      />
    );
};

export default MarketClusteringComponent;
